import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../../../../@core/components/ui/button/button.component';
import { CONTRACT_USER_ROLE } from '../../../../../@core/models/model';
import { EditContractDataService } from '../../../../services/edit-contract-data.service';

@Component({
    selector: 'app-milestones-tab',
    standalone: true,
    imports: [CommonModule, ButtonComponent],
    template: `
        <div class="flex flex-col h-full p-4 overflow-auto">
            <div *ngIf="milestones().length === 0"
                class="flex-1 flex flex-col items-center justify-center text-center">
                <div class="text-gray-500 mb-4">
                    <i class="pi pi-flag text-4xl"></i>
                </div>
                <h3 class="text-lg font-semibold text-gray-700 mb-2">No Milestones Yet</h3>
                <p class="text-gray-500 text-sm mb-4">Add milestones to track important dates and deliverables</p>
            </div>

            <div *ngIf="milestones().length > 0" class="flex-1 overflow-y-auto">
                <div class="space-y-4 text-sm text-gray-700">
                    @for(milestone of milestones(); track milestone._id){
                    <div class="flex gap-2 items-center justify-between">
                        <div class="flex gap-2 items-center">
                        <i class="pi pi-check-circle"
                            [ngClass]="checkDueDatePassed(milestone.date) ? 'text-green-500' : ''"></i>
                        <span class="font-medium whitespace-nowrap overflow-x-auto">{{ milestone.name }}</span>
                        </div>
                        <span class="text-gray-500 text-xs whitespace-nowrap overflow-x-auto">{{ milestone.date | date }}</span>
                    </div>
                    }
                </div>
            </div>

            <div class="mt-4 pt-4 flex items-center justify-center">
                @if(currentRole() === CONTRACT_USER_ROLE.OWNER || currentRole() === CONTRACT_USER_ROLE.EDITOR){
                <app-button
                    label="Update Milestone"
                    icon="pi pi-plus"
                    severity="primary"
                    (clicked)="toggleMilestonesDialog()" />
                }
            </div>
        </div>
    `,
    styles: [`
        :host {
            display: block;
            height: 100%;
            width: 100%;
        }
    `]
})
export class MilestonesTabComponent {
    CONTRACT_USER_ROLE = CONTRACT_USER_ROLE;

    constructor(public dataService: EditContractDataService) { }

    // Use getter methods to access computed signals from the service - these will auto-update!
    get milestones() { return this.dataService.milestones; }
    get currentRole() { return this.dataService.currentRole; }

    checkDueDatePassed(date: Date | string | null): boolean {
        const data = this.dataService.getData();
        if (data && data.parent) {
            return data.parent.checkDueDatePassed(date);
        }
        return false;
    }

    toggleMilestonesDialog() {
        const data = this.dataService.getData();
        if (data && data.parent) data.parent.toggleMilestonesDialog();
    }
}

